export enum Product {
  TERM_LIFE_INSURANCE_CONSTANT = "termLifeInsuranceConstant",
  PILLAR_3A_CONSTANT = "pillar3aConstant",
}
